const $ = jQuery.noConflict();

class ImageLinkSlider {
    constructor() {
        this.sliderLeft = $('.block-ils-slider__left');
        this.sliderRight = $('.block-ils-slider__right');
    }

    init() {
        this.hideSlick();
    }

    hideSlick() {
        let slideCount = this.sliderLeft[0].slick.slideCount;

        if ( 4 > slideCount ) {
            this.sliderLeft.slick(
                'slickSetOption',
                {
                    swipe: false,
                },
            );
            this.sliderRight.slick(
                'slickSetOption',
                {
                    dots: false,
                },
            );
            this.sliderRight.find('.slick-dots').remove();
        }
    }
}

export default new ImageLinkSlider();